// extracted by mini-css-extract-plugin
export default {"container":"Signup_container__BjwMi","innerbox":"Signup_innerbox__0sHqf","footers":"Signup_footers__wRFIz","error":"Signup_error__-j7nO"};